export default {
  title: {
    en: 'You skipped {count, plural, one {# month} other {# months}}',
  },
  text: {
    en: `
      <p>Your next fragrance is scheduled to ship on {dateRange}.</p>
      <p>We won't bill you for the skipped {count, plural, one {month} other {months}}, 
      and you won't be charged until you're scheduled to receive products again.</p>
    `,
  },
  finishButton: {
    en: 'Finish',
  },
}
